import { render, staticRenderFns } from "./IncomeFunction.vue?vue&type=template&id=0fc587dc&scoped=true&"
import script from "./IncomeFunction.vue?vue&type=script&lang=js&"
export * from "./IncomeFunction.vue?vue&type=script&lang=js&"
import style0 from "./IncomeFunction.vue?vue&type=style&index=0&id=0fc587dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc587dc",
  null
  
)

export default component.exports